export default function installPolyfills() {
  if (typeof Object.hasOwn === 'function') return;

  Object.defineProperty(Object, 'hasOwn', {
    value: (object, property) => Object.getOwnPropertyDescriptor(object, property) !== undefined,
    configurable: true,
    writable: true,
  });
}
